import urlParse from 'url-parse';

import runtime from './runtime';
import logger from '../logger';

export function checkTraceName(traceName) {
  if (!traceName) {
    logger.warn('[performance-collect] route name 未定义，请确认 routeConfig 包含当前路径')
    return false
  }

  return true
}